import { ReactElement } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface TabItem {
  path: string;
  label: string;
  icon?: React.ReactNode;
}

interface TabMenuProps {
  tabs: TabItem[];
  basePath: string;
  className?: string;
}

export default function TabMenu({ tabs, basePath, className = '' }: TabMenuProps): ReactElement {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <div className={`cr-w-full ${className}`}>
      <nav className="cr-flex cr-flex-wrap cr-gap-2" aria-label="Tabs">
        {tabs.map((tab) => {
          const tabPath = `${basePath}/${tab.path}`;
          const isActive = currentPath === tabPath || (tab.path === '' && currentPath === basePath);

          return (
            <Link
              key={tab.path}
              to={tabPath}
              className={`cr-flex cr-flex-1 cr-items-center cr-justify-center
                cr-gap-x-2 cr-rounded-md cr-px-4 cr-py-2.5 cr-text-base cr-font-semibold
                cr-no-underline sm:cr-w-auto sm:cr-flex-initial
                ${isActive ? 'cr-bg-[#03365D] cr-text-white' : 'cr-bg-[#B0C9D1] cr-text-[#03365D] hover:cr-bg-[#d3d3d3]'}
                cr-transition-colors cr-duration-200
              `}
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              {tab.label}
              {tab.icon && <span className="cr-m-0">{tab.icon}</span>}
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
